export default {
  'menu.welcome': 'Сводка',
  'menu.dashboard': 'Сводка',
  'menu.monitoring': 'Мониторинг',
  'menu.communicationsList': 'Список коммуникаций',
  'menu.communicationEditor': 'Редактор коммуникаций',
  'menu.school': 'Школа',
  'menu.projects': 'Проекты',
  'menu.documents': 'Документы',
  'menu.more-blocks': 'Больше блоков',
  'menu.home': 'Главная',
  'menu.login': 'Вход',
  'menu.register': 'Регистрация',
  'menu.register-result': 'Результат регистрации',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.profile': 'Профиль',
  'menu.profile.basic': 'Основной профиль',
  'menu.profile.advanced': 'Расширенный профиль',
  'menu.result': 'Результат',
  'menu.result.success': 'Успех',
  'menu.result.fail': 'Неудача',
  'menu.exception': 'Исключение',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Триггер',
  'menu.account': 'Аккаунт',
  'menu.account.center': 'Центр аккаунта',
  'menu.account.settings': 'Настройки аккаунта',
  'menu.account.trigger': 'Ошибка триггера',
  'menu.account.logout': 'Выйти',
  'menu.editor': 'Графический редактор',
  'menu.editor.flow': 'Редактор потоков',
  'menu.editor.mind': 'Редактор разума',
  'menu.editor.koni': 'Редактор Koni',
  'menu.infrastructure': 'Инфраструктура',
  'menu.infrastructure.users': 'Пользователи',
  'menu.infrastructure.usersCards': 'Пользователи (Карточки)',
  'menu.infrastructure.roles': 'Роли',
  'menu.subject': 'Субъекты',
  'menu.subject.subjectTypes': 'Типы субъектов',
  'menu.subject.subjects': 'Субъекты',
  'menu.subject.organizations': 'Организации',
  'menu.users': 'Пользователи',
  'menu.roles': 'Роли',

  // @generated entity-menu
  'menu.communication': 'Коммуникации',
  'menu.communication.communication': 'Коммуникация',
  'menu.communication.communicationDetail': 'Деталь коммуникации',
  'menu.communication.communicationFolder': 'Папка коммуникации',
  'menu.communication.communicationHistory': 'История коммуникации',
  'menu.communication.communicationPermission': 'Разрешение коммуникации',
  'menu.communication.communicationStrategy': 'Стратегия коммуникации',
  'menu.communication.communicationSubject': 'Субъект коммуникации',
  'menu.communication.communicationVersion': 'Версия коммуникации',
  'menu.communication.communicationView': 'Представление коммуникации',
  'menu.communication.typeSubjectCommunication': 'Тип субъекта коммуникации',
  'menu.context': 'Контекст',
  'menu.context.promptTemplates': 'Шаблоны промптов',
  'menu.context.contextClassifier': 'Классификатор контекста',
  'menu.context.contextData': 'Элемент данных контекста',
  'menu.context.contextPipeline': 'Конвейер контекста',
  'menu.context.contextStorage': 'Хранилище контекста',
  'menu.context.groupContextClassifier': 'Группа классификаторов контекста',
  'menu.context.providerContext': 'Контекст провайдера',
  'menu.context.providerContextClassifier': 'Классификатор контекста провайдера',
  'menu.context.resultContextClassifier': 'Итоговый классификатор контекста',
  'menu.context.shareContextStorage': 'Общее хранилище контекста',
  'menu.context.typeProviderContext': 'Тип контекста провайдера',
  'menu.context.versionProviderContext': 'Версия контекста провайдера',
  'menu.infrastructure.permission': 'Разрешение (доступ)',
  'menu.infrastructure.role': 'Роль',
  'menu.infrastructure.user': 'Пользователь',
  'menu.services': 'Сервисы',
  'menu.services.aiModel': 'Модель ИИ',
  'menu.services.brokerEvent': 'Событие брокера',
  'menu.services.dataPipeline': 'Конвейер данных',
  'menu.services.dataPipelineDetail': 'Детализация конвейера данных',
  'menu.services.dependentVersionService': 'Зависимость версии сервиса',
  'menu.services.detailScheduler': 'Элемент выполнения планировщика',
  'menu.services.historyRunningPipeline': 'История запуска конвейера',
  'menu.services.historyRunningStreamPipeline': 'История потокового конвейера',
  'menu.services.injectionVersionService': 'Injection Version Service',
  'menu.services.pipeline': 'Конвейер',
  'menu.services.resultScheduler': 'Результат планировщика',
  'menu.services.running': 'Тип выполнения',
  'menu.services.scheduler': 'Планировщик',
  'menu.services.schemaPipeline': 'Схема конвейера',
  'menu.services.service': 'Сервис',
  'menu.services.serviceEvent': 'Событие сервиса',
  'menu.services.serviceParams': 'Параметры сервиса',
  'menu.services.serviceType': 'Тип сервиса',
  'menu.services.serviceVersion': 'Версия сервиса',
  'menu.services.testPipeline': 'Тестовый конвейер',
  'menu.services.testResultPipeline': 'Результат тестового конвейера',
  'menu.services.tuneModel': 'Задача дообучения',
  'menu.services.tuneModelResult': 'Результат дообучения модели',
  'menu.subject.application': 'Приложение',
  'menu.subject.division': 'Подразделение',
  'menu.subject.individual': 'Физическое лицо',
  'menu.subject.organization': 'Организация',
  'menu.subject.organizationPosition': 'Позиция организации',
  'menu.subject.organizationStructure': 'Организационная структура',
  'menu.subject.organizationStructurePermission': 'Доступ к оргструктуре',
  'menu.subject.subject': 'Субъект',
  'menu.subject.subjectType': 'Тип субъекта',
  'menu.subject.userOrganizationStructure': 'Пользователь в оргструктуре',
};
